<template>
  <a
    href="#"
    class="feed-item border-[1.5px] border-gray-400 bg-gray-100 rounded-lg p-2 w-full flex flex-row items-center mb-3"
  >
    <div class="icon bg-gray-100 rounded-lg p-2">
      <svg
        width="18px"
        height="18px"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          d="M9.002 2.5a.75.75 0 01.691.464l6.302 15.305 2.56-6.301a.75.75 0 01.695-.468h4a.75.75 0 010 1.5h-3.495l-3.06 7.532a.75.75 0 01-1.389.004L8.997 5.21l-3.054 7.329A.75.75 0 015.25 13H.75a.75.75 0 010-1.5h4l3.558-8.538a.75.75 0 01.694-.462z"
        />
      </svg>
    </div>
    <div class="feed-details font-semibold flex flex-row justify-between w-full">
      <div class="feed-topic flex flex-col px-3">
        <span class="text-sm text-blue-600 font-semibold">{{ title }}</span>
        <span class="text-xs text-gray-700">{{ subtitle }}</span>
      </div>
      <div class="feed-meta text-right pr-3">
        <span class="text-xs text-gray-700">{{ time }}</span>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'title'
    },
    subtitle: {
      type: String,
      default: 'subtitle'
    },
    time: {
      time: String,
      default: '09:20:01'
    }
  }
}
</script>
